@let practiceLocation = practiceLocationHeader$ | async;
@let isIop = practiceLocation?.type === SelectedLocationType.Iop;
@let isPscSwitched = practiceLocation?.type === SelectedLocationType.PscSwitched;
@let timeZone = timeZone$ | async;

<div class="practice-location-header">
  @if (practiceLocation?.type) {
    @if (isIop) {
      <div class="practice-location-header-part">
        <span class="practice-location-header-part-emphasis">Practice:</span>
        <span
          class="practice-name"
          [uiKitTextTooltip]="practiceLocation?.practiceName ?? ''"
          nzTooltipPlacement="bottom"
        >
          {{ practiceLocation?.practiceName }}
        </span>
      </div>
    } @else {
      <div class="practice-location-header-part">
        <span class="practice-location-header-part-emphasis">Account:</span>
        <span
          class="practice-name"
          [uiKitTextTooltip]="practiceLocation?.accountName ?? ''"
          nzTooltipPlacement="bottom"
        >
          {{ practiceLocation?.accountName }}
        </span>
      </div>
    }

    @if (isIop || isPscSwitched) {
      <div class="practice-location-header-part">
        <span class="practice-location-header-part-emphasis">Location:</span>
        <span
          class="practice-name"
          [uiKitTextTooltip]="practiceLocation?.locationName ?? ''"
          nzTooltipPlacement="bottom"
        >
          {{ practiceLocation?.locationName }}
        </span>
      </div>
    }

    <div class="practice-location-header-part">
      <span class="practice-location-header-part-emphasis">Loc. Timezone:</span>
      <span class="practice-name" [uiKitTextTooltip]="timeZone?.description ?? ''" nzTooltipPlacement="bottom">
        {{ timeZone?.code }}
      </span>
    </div>
  }
</div>
